import React from "react";
import { ToastContext, ToastContextConsumer } from "../contexts/toast_context.js";
import { ToastTypeSuccess, ToastTypeError, ToastTypeWarning, ToastTypeInfo } from '../base/toasts/constants.js';

/**
 * Use for showing modal windows
 * @component
 * @category HOC
 * @param providedProps
 * @param {func(message, params)} providedProps.showSuccessMessage - Function for showing green success message
 * @param {func(message, params)} providedProps.showErrorMessage - Function for showing red error message
 * @param {func(message, params)} providedProps.showWarningMessage - Function for showing yellow warning message
 * @param {func(errorResponse, params)} providedProps.showServerErrorIfNeed - Function for red error message (shows only if error fields not described in errorResponse)
*/

const WithShowToast = (Component) => {

  class WithShowToast extends React.Component {

    showMessage = (type, message, params = {}) => {
      this.context.showToast(type, message, params)
    }

    showSuccessMessage = (message, params = {}) => {
      this.showMessage(ToastTypeSuccess, message, params)
    }

    showErrorMessage = (message, params = {}) => {
      this.showMessage(ToastTypeError, message, params)
    }

    showInfoMessage = (message, params = {}) => {
      this.showMessage(ToastTypeInfo, message, params)
    }

    showWarningMessage = (message, params = {}) => {
      this.showMessage(ToastTypeWarning, message, params)
    }

    showServerErrorIfNeed = (errorResponse, params = {}) => {
      const { message, errorData } = errorResponse;
      if(!message || errorData) {
        return;
      }
      this.showMessage(ToastTypeError, message, params);
    } 

    render() {
      return (
        <ToastContextConsumer>
          { context => 
            <Component { ...this.props } 
                       toastContext = { context } 
                       toastShowed = { context.toastShowed }
                       toast = { context.toast }
                       showSuccessMessage = { this.showSuccessMessage }
                       showErrorMessage = { this.showErrorMessage }
                       showWarningMessage = { this.showWarningMessage }
                       showServerErrorIfNeed = { this.showServerErrorIfNeed }/>
          }
        </ToastContextConsumer>
      )
    }
  }

  WithShowToast.contextType = ToastContext;

  return WithShowToast;
};

export default WithShowToast;